// extracted by css-extract-rspack-plugin
export default {"cls1":"CenteredDiv-cls1_91j","cls2":"CenteredDiv-cls2_aOM CenteredDiv-cls1_91j"};